module.exports = __webpack_public_path__ + "media/parents/graduate-and-parent-4b90fc73.jpg";